import React from "react";
import Button from "@material-ui/core/Button";
import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar,
  SelectInput,
  NumberInput,
  ReferenceInput,
  useTranslate,
} from "react-admin";

import { OperateCallback } from "../../../components/OperateCallback";

const validateEdition = (values) => {
  const errors = {};
  if (!values.order) {
    errors.order = ["The order is required"];
  }
  return errors;
};

const EditToolbar = ({ onCancel, ...props }) => {
  const translate = useTranslate();
  return (
    <Toolbar {...props}>
      <OperateCallback props={props} operate="edit" />
      <Button onClick={onCancel}>{translate("ra.action.cancel")}</Button>
    </Toolbar>
  );
};

const SystemRouteEdit = ({ onCancel, ...props }) => (
  <Edit title=" " {...props}>
    <SimpleForm
      validate={validateEdition}
      toolbar={<EditToolbar onCancel={onCancel} />}
    >
      <TextInput disabled source="id" />
      <TextInput source="permissions" label="ra.sources.permissions_path" />
      <ReferenceInput
        source="parent"
        reference="system/route/parent"
        label="ra.sources.parent"
      >
        <SelectInput optionText="name" optionValue="id" />
      </ReferenceInput>
      <TextInput
        source="description"
        label="ra.sources.description"
        multiline={true}
        fullWidth={true}
      />
      <NumberInput source="order" label="ra.sources.order" />
      <SelectInput
        source="isMenu"
        label="ra.sources.is_menu"
        choices={[
          { id: 1, name: "ra.sources.yes" },
          { id: 0, name: "ra.sources.no" },
        ]}
      />
      <SelectInput
        source="isPermissions"
        label="ra.sources.is_permissions"
        choices={[
          { id: 1, name: "ra.sources.yes" },
          { id: 0, name: "ra.sources.no" },
        ]}
      />
    </SimpleForm>
  </Edit>
);

export default SystemRouteEdit;
